module.exports = __webpack_public_path__ + "media/img/illustrations/icons/action-delete-e2b0cf267de7332dd609741deec3486f.svg";